import PasswordRevealInput from 'components/Inputs/PasswordRevealInput/PasswordRevealInput';

export default PasswordRevealInput;
